import MyFooter from "../components/MyFooter";
import { Outlet, Route, Link, Routes, useLocation } from "react-router-dom";
import MyHeader from "../components/MyHeader";
import React from "react";
import ReactDOM from "react-dom";
import i18n from "../i18n";
import ReactLoading from "react-loading";
import { useSelector } from "react-redux";
import { blurAll, disableBlurAll, loadingStyle } from "../common/mainStyle";
import { purgeData, store } from "..";
import MyResultModal from "../components/modal/MyResultModal";
import MyAuctionSubmitModal from "../components/modal/MyAuctionSubmitModal";
import MyBuyTurnModal from "../components/modal/MyBuyTurnModal";
import MyBuyTurnModal_v2 from "../components/modal/MyBuyTurnModal_v2";
import MyConfirmModal from "../components/modal/MyConfirmModal";

const Layout = () => {
  let loadingGlobal = useSelector((state) => state.LoadingReducer);
  let modalReducer = useSelector((state) => state.ModalReducer);

  console.log("loadingGlobal: " + JSON.stringify(loadingGlobal));
  console.log("modalReducer: " + JSON.stringify(modalReducer));

  // check login
  const location = useLocation();
  console.log("location " + location.pathname.toUpperCase());

  let isShowHeader =
    location.pathname.toUpperCase() !== "/LOGIN" &&
    location.pathname.toUpperCase() !== "/FLASH" &&
    location.pathname.split("/").length == 2;

  console.log("isShowHeader " + isShowHeader);

  return (
    <div>
      {isShowHeader ? (
        <div className="main">
          {loadingGlobal ? (
            <ReactLoading
              className="loading-box"
              type={"spinningBubbles"}
              color={"#ffffff"}
              height={60}
              width={60}
              style={loadingStyle}
            />
          ) : (
            <div></div>
          )}
          <MyHeader changeLanguage={{}} />
          <div
            id="content"
            className={loadingGlobal ? "blur-container content" : "content"}
          >
            <Outlet />
          </div>
          <MyFooter />
        </div>
      ) : (
        <div>
          {loadingGlobal ? (
            <ReactLoading
              className="loading-box"
              type={"spinningBubbles"}
              color={"#ffffff"}
              height={60}
              width={60}
              style={loadingStyle}
            />
          ) : (
            <div></div>
          )}
          <div
            id="content"
            className={loadingGlobal ? "blur-container content" : "content"}
            style={!isShowHeader ? { padding: "0px" } : {}}
          >
            <Outlet />
          </div>
        </div>
      )}
      <MyResultModal isOpenOtp={modalReducer.result} />

      <MyAuctionSubmitModal isOpenOtp={modalReducer.auction_submit} />

      <MyBuyTurnModal_v2 isOpenOtp={modalReducer.buyTurn} />

      <MyConfirmModal isOpenOtp={modalReducer.confirm} />
    </div>
  );
};

export default Layout;
